import { render } from "./AddSpecification.vue?vue&type=template&id=2eae7fe7&scoped=true"
import script from "./AddSpecification.vue?vue&type=script&lang=js"
export * from "./AddSpecification.vue?vue&type=script&lang=js"

import "./AddSpecification.vue?vue&type=style&index=0&id=2eae7fe7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eae7fe7"]])

export default __exports__